<script>
import { onMount } from 'svelte';
import { num1K1MFormatter } from '../common.js';
import Chart from 'chart.js';
import * as ChartAnnotation from 'chartjs-plugin-annotation';

export let bgCssClass = 'bg-primary'
export let iconClass = 'fas fa-bicycle';
export let title = '-';
export let data = {};
export let yaxisLabel = ''
export let datefield = 'tripstartdate'
export let valuefield = 'dailycount'

// get max value from 2019
let max2019 = Math.max(...data.series2019.map(x => x[valuefield]))
let max2020 = Math.max(...data.series2020.map(x => x[valuefield]))
let maxValue = (max2020 > max2019) ? max2020 : max2019;

let chartTarget;

onMount(async () => {

  // var ctx = document.getElementById('myChart');
  // chartTarget.width = '100%';
  // chartTarget.height = '500px';
  var myChart = new Chart(chartTarget, {
      type: 'line',
      data: {
          labels: data.series2019.map(x => (new Date(x[datefield])).toLocaleString('default', { month: 'short', day: 'numeric' })),
          datasets: [{
            label: '2019',
            fill: false,
            borderColor: data.color2019,
            data: data.series2019.map(x => x[valuefield])
          },{
            label: '2020',
            fill: false,
            borderColor: data.color2020,
            data: data.series2020.map(x => x[valuefield])
          }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        chartArea: {
          backgroundColor: 'rgba(0, 0, 0, 0.4)'
        },
        legend: {
            display: true,
            labels: {
                fontColor: '#fff',
            }
        },
        scales: {
          xAxes: [{
              // type: 'time',
              ticks: {
                // display: false,
                autoSkip: true,
                maxTicksLimit: 14,
                fontColor: '#fff'
              }
          }],
          yAxes: [{
            scaleLabel: {
                display: false,
                labelString: yaxisLabel,
                fontColor: '#fff'
              },
              ticks: {
                fontColor: '#fff',
                callback: (value, index, values) => {
                  if (value > 1000) {
                    return value/1000+'k';
                  }
                  return value.toLocaleString();
                }
              }
          }]
        },
        annotation: {
          events: ["click"],
          annotations: [
            {
              drawTime: "beforeDatasetsDraw",
              type: "box",
              xScaleID: "x-axis-0",
              yScaleID: "y-axis-0",
              xMin: "23 Mar",
              xMax: "31 Aug",
              yMin: 0,
              yMax: maxValue,
              backgroundColor: "rgba(201, 3, 171, 0.5)",
              borderColor: "rgb(201, 3, 171)",
              borderWidth: 1
            },
            {
              drawTime: "beforeDatasetsDraw",
              type: "box",
              xScaleID: "x-axis-0",
              yScaleID: "y-axis-0",
              xMin: "10 May",
              xMax: "31 Aug",
              yMin: 0,
              yMax: maxValue,
              backgroundColor: "rgba(101, 33, 171, 1)",
              borderColor: "rgb(101, 33, 171)",
              borderWidth: 1,
              // onClick: function(e) {
              //   console.log("First steps to easing lockdown", e.type, this);
              // }
            },
          ]
        }
      }
  });
});

</script>

<section class="{`${bgCssClass} sectionx hero is-fullheight`}">
  <div class="hero-body">
    <div class="container">
      <h2 class="ioreveal animate__animated" data-anicss="animate__fadeInDown"><i class="{iconClass}"></i> {title}</h2>
      <p class="note">
        <span style="background-color: rgba(201, 3, 171, 0.5); display: inline-block; width: 20px; height: 20px">&nbsp;</span>
        UK Lockdown 23rd March
      </p>
      <p class="note">
        <span style="background-color: rgba(101, 33, 171, 1); display: inline-block; width: 20px; height: 20px">&nbsp;</span>
        First easing of Lockdown 13th May
      </p>
      <div class="chart-container">
        <canvas bind:this="{chartTarget}"></canvas>
      </div>
    </div>
  </div>
</section>

<style>

canvas {
  /* max-width:60vw !important; */
  width:60vw;
  height:50vh;
  /* background-color: #f00; */
}

.chart-container {
  position: relative;
  height:50vh;
  width:100%;
  /* width:60vw; */
  border: solid 0 #fff;
}

.note {
  margin-top: 2px;
}


@media (max-width: 640px) {
  .chart-container {
    width:100%;
  }
  canvas {
    max-width: 100vw !important;
  }
  .note {
    font-size: 12px;
  }
}

@media (min-width: 641px) and  (max-width: 1000px) {
  .chart-container {
    width:80vw;
  }
  canvas {
    width:80vw;
    max-width: 800vw !important;
  }
}
</style>